import { render, staticRenderFns } from "./BNT.vue?vue&type=template&id=4059e226"
import script from "./BNT.vue?vue&type=script&lang=js"
export * from "./BNT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports